import { FC, ReactNode } from 'react';

import { Button } from '../button';
import { Modal } from '../modal';

export interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: ReactNode;
  confirmText: string;
  cancelText?: string;
  onConfirm: () => void;
  /** Also what the close cross and Escape do: dismissing is never the destructive path. */
  onCancel: () => void;
  /** A sheet at the bottom edge on phones — for questions asked mid-meeting. */
  sheetOnMobile?: boolean;
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText = 'Отмена',
  onConfirm,
  onCancel,
  sheetOnMobile = false,
}) => (
  <Modal
    isOpen={isOpen}
    title={title}
    onClose={onCancel}
    sheetOnMobile={sheetOnMobile}
    footer={
      <>
        <Button size="md" variant="neutral" className="flex-1" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button size="md" variant="dark" className="flex-1" onClick={onConfirm}>
          {confirmText}
        </Button>
      </>
    }
  >
    <p className="text-body-s-strong text-ink-muted md:text-body-l-strong">{message}</p>
  </Modal>
);
